import cx from "classnames";
import "./NetworkDropdown.scss";

import { useMemo } from "react";

import CheckIcon from "assets/icons/CheckIcon";
import { formatNumber, NumberFormatType } from "lib/numbers";
import { NUMBER_FORMATING_KEY } from "sdk/configs/storageKey";

type Props = {
  currentLanguage: string | undefined;
  onClose: () => void;
};

export const getLanguageName = (langCode: string) => {
  const displayNames = new Intl.DisplayNames([langCode], { type: "language" });
  return displayNames.of(langCode);
};

export default function NumberFormatModalContent({ currentLanguage, onClose }: Props) {
  const currentFormat = useMemo(() => {
    return localStorage.getItem(NUMBER_FORMATING_KEY);
  }, []);
  return (
    <>
      {Object.values(NumberFormatType).map((item) => {
        const isActive = currentFormat ? currentFormat === item : item === NumberFormatType.COMMA;
        return (
          <div
            key={item}
            className={cx("network-dropdown-menu-item  menu-item language-modal-item", {
              active: isActive,
            })}
            onClick={() => {
              localStorage.setItem(NUMBER_FORMATING_KEY, item);
              onClose();
              setTimeout(() => {
                window.location.reload();
              }, 350);
            }}
          >
            <div className="menu-item-group">
              <p className="language-item">
                {/* {getLanguageName(item)} */}
                {formatNumber(1234.56, {
                  formatType: item,
                })}
              </p>
            </div>
            <div className="network-dropdown-menu-item-img">
              {isActive && <CheckIcon className="language-checked-icon" />}
            </div>
          </div>
        );
      })}
    </>
  );
}
